
import { NativeDateAdapter } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {

  // datePipe: DatePipe = new DatePipe('pl-PL');
  
  getFirstDayOfWeek(): number {
    return 1;
  }

}
